export default __webpack_public_path__ + "static/media/HostNegotiationBG.b0bd6dc9.jpg";